import React from 'react';
import Container from 'container';
import Img from 'img';
import s from './lp_sole_image.module.scss';

export default function SoleImageSection({
  image
}) {
  return (
    <>
      <Container className={s.root}>
        <Img
          className={s.image}
          src={image}
          alt={image?.id}
        />
      </Container>

      <hr className={s.line} />
    </>
  );
}
